export const LINK_TITLE = `В сравнение`;
export const ACTIVE_TEXT = `Из сравнения`;
